import { api_react_v1_events_path } from '@routes';

import request from './request';

export const EVENT_LIST_KEY = 'EVENT_LIST_KEY';

export interface SanitizedEventParams {
  page: number;
}

export interface Event {
  date: string;
  highlight: string;
  image: string;
  location: string;
  name: string;
  slug: string;
  additionalDayTimes?: string;
}

export interface EventsResult {
  pastEvents: Event[];
  nextPage?: number;
}

export async function getEvents(parameters?: SanitizedEventParams): Promise<EventsResult> {
  const resp = await request('get', api_react_v1_events_path(parameters || {}));
  return resp;
}
